if (!customElements.get('calista-faq')) {
  customElements.define(
    'calista-faq',
    class CalistaFaq extends HTMLElement {
      connectedCallback() {
        if (this.dataset.closeOthers !== 'true') return;
        this.querySelectorAll('details').forEach((item) => {
          item.addEventListener('toggle', () => {
            if (!item.open) return;
            this.querySelectorAll('details').forEach((other) => {
              if (other !== item) other.removeAttribute('open');
            });
          });
        });
      }
    }
  );
}
